/**
 * 登录后回跳路径的安全校验：只允许站内绝对路径，防止开放重定向（`?redirect=https://evil.com`）。
 * 不合法一律回退到 fallback。
 */
export function safeRedirectPath(raw: string | null | undefined, fallback = "/app"): string {
  if (!raw) return fallback;
  if (!raw.startsWith("/")) return fallback;
  // `//evil.com`、`/\evil.com` 会被浏览器当成协议相对 URL
  if (raw.startsWith("//") || raw.includes("\\")) return fallback;
  // 控制字符（换行等）一律拒绝
  if (/[\u0000-\u001f]/.test(raw)) return fallback;
  return raw;
}
